import {
  each,
  extend,
  filter,
  find,
  go,
  identity,
  isArray,
  keys,
  map,
  mapObject,
  omit,
  pick,
  reject,
  sel,
} from 'fxjs/es';
import { VectorEditorConstantS } from '../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';

export const makeLangCollaboSql = (lang_col) => {
  if (lang_col == 'kr') return SQL`bp.is_use=false`;
  if (lang_col == 'en') return SQL`bp.is_use_en=false`;
  if (lang_col == 'jp') return SQL`bp.is_use_jp=false`;
  if (lang_col == 'kr_line') return SQL`bp.is_use_line=false`;
  if (lang_col == 'en_line') return SQL`bp.is_use_line_en=false`;
};

const whereSql = (is_not_use, query, params) =>
  is_not_use
    ? makeLangCollaboSql(query.lang_col)
    : SQL`
  ${G.enCL_collabo('bp.is_use')}=true AND
  bp.base_product_color_face_url is not null AND
  bp.cate_list_id=${parseInt(params.cate_list_id)}
`;

export const makeProductListSubQuerySql =
  (is_not_use) =>
  ({ query, params }) => {
    const custom_query = pick(
      filter((key) => key.match(/f_\d/), keys(query)),
      extend(
        query,
        mapObject((val) => (isArray(val) ? go(val, map(parseInt), filter(identity)) : val), query),
      ),
    );
    const f_tag = reject((id) => !id || id == -1, query.f_tag);
    return SQL`
    SELECT bp.id
    FROM base_products as bp ${SQLS([
      query.f_color
        ? SQL`
      INNER JOIN
        base_product_colors as bpc
      ON
        bpc.base_product_id=bp.id AND
        bpc.is_public=true AND
        bpc.is_hidden=false AND ${IN('bpc.color_filter_id', query.f_color)}`
        : SQL``,
      query.f_size
        ? SQL`
      INNER JOIN
        base_product_sizes as bps
      ON
        bps.base_product_id=bp.id AND
        bps.is_public=true AND
        bps.is_hidden=false AND ${IN('bps.size_filter_id', query.f_size)}`
        : SQL``,
      query.f_tag
        ? (function (query) {
            if (f_tag.length) {
              /* 세일 말고도 체크된게 있음 */
              if (_p.index_of(query.f_tag, -1) > -1) {
                /* 그중에 세일이 체크되어있음 */
                return SQL`
              INNER JOIN type_categories as tc
              ON 
                ${EQ({
                  'tc.attached_id': CL('bp.id'),
                  'tc.attached_type': 'bp_tag_filters',
                })}
              INNER JOIN categories as c
              ON
                tc.category_id=c.id AND
                c.is_hidden=false AND
                c.is_public=true AND
                (${IN('c.id', f_tag)} OR ${G.enCL_collabo('bp.original_price')} > ${G.enCL_collabo(
                  'bp.price',
                )})`;
              } else {
                /* 세일은 체크안되어 있음 */
                return SQL`
              INNER JOIN type_categories as tc
              ON 
                ${EQ({
                  'tc.attached_id': CL('bp.id'),
                  'tc.attached_type': 'bp_tag_filters',
                })}
              INNER JOIN categories as c
              ON
                tc.category_id=c.id AND ${IN('c.id', f_tag)}`;
              }
            } else {
              /* 세일만 체크 되었음 */
              return SQL`
            INNER JOIN type_categories as tc
            ON 
              ${EQ({
                'tc.attached_id': CL('bp.id'),
                'tc.attached_type': 'bp_tag_filters',
              })}
            INNER JOIN categories as c
            ON
              tc.category_id=c.id AND
              c.is_hidden=false AND
              c.is_public=true AND
              ${G.enCL_collabo('bp.original_price')} > ${G.enCL_collabo('bp.price')}`;
            }
          })(query)
        : SQL``,
    ])}
    WHERE 
      ${whereSql(is_not_use, query, params)}
      AND ${EQ({
        'bp.is_hidden': false,
        'bp.is_public': true,
      })}
      ${SQLS(
        [
          query.cate_item_id
            ? SQL`
      AND bp.cate_item_id=${parseInt(query.cate_item_id)}`
            : SQL``,
          G.collabo_type == '' && query.f_brand
            ? SQL`
      AND ${IN('bp.brand_filter_id', query.f_brand)}`
            : SQL``,
        ].concat(
          map(
            ([key, ids]) => SQL`
      AND bp.id in (
        SELECT b.id
        FROM base_products as b, bp_filter_lists as bfl, bp_filter_list_filter_items as bflfi, filter_items as f
        WHERE
          f.is_hidden=false AND
          f.is_public=true AND
          b.id=bfl.base_product_id AND
          bfl.filter_list_id = ${parseInt(key.replace('f_', ''))} AND
          bflfi.bp_filter_list_id=bfl.id AND
          ${
            !isArray(ids) && key == 'f_29'
              ? SQL`bflfi.filter_item_id IN (${ids})`
              : IN('bflfi.filter_item_id', ids)
          })`,
            Object.entries(custom_query),
          ),
        ),
      )}`;
  };

export const productListQuery = async (req, is_not_use) => {
  req.query.ordering = req.query.ordering || 'no';
  if (!is_not_use)
    await go(
      _p.is_numeric(req.params.cate_list_id) &&
        R.QUERY1`
        SELECT id 
        FROM cate_lists 
        WHERE id=${parseInt(req.params.cate_list_id)} 
        ORDER BY no LIMIT 1;`,
      (r) => (!r ? Promise.reject(Error('No cate_list referer:' + req.headers.referer)) : r),
    );
  return await go(
    req,
    makeProductListSubQuerySql(is_not_use),
    (subquery) =>
      Promise.all([
        R.ASSOCIATE`
        base_products ${{
          query: SQL`
          WHERE 
            base_products.id in (${subquery}) AND base_products.id != 2984
            ${
              req.query.is_change_bp == 'true'
                ? SQL`AND ${NOT_IN('base_products.maker_type', VectorEditorConstantS.EDITOR_TYPES)}`
                : EMPTY
            }
            ORDER BY ${get_base_product_ordering(req.query.ordering)}
            OFFSET ${req.query.offset || 0}
            LIMIT ${req.query.limit || null}`,
          column: CL(
            'id',
            'product_color_id',
            G.en_as_collabo('name'),
            G.en_as_collabo('original_price'),
            G.en_as_collabo('price'),
            G.en_as_collabo('print_price'),
            G.en_as('model_thumb_url'),
            'cate_list_id',
            'cate_item_id',
            'is_color_for_list',
            'is_size_for_list',
          ),
        }}
          < base_product_tags ${{
            column: CL(G.en_as('name')),
            query: SQL`ORDER BY no`,
          }}
          < base_product_colors ${{
            column: CL('id', 'color_filter_id', 'product_thumb_url', 'color_code', 'is_thumb'),
            query: SQL`WHERE ${EQ({
              'base_product_colors.is_hidden': false,
              ['base_product_colors.is_public' + G._collabo]: true,
            })} ORDER BY base_product_colors.no`,
          }}
          < base_product_sizes ${{
            column: CL('id', G.en_as('short_name')),
            query: SQL`WHERE ${EQ({
              'base_product_sizes.is_hidden': false,
              'base_product_sizes.is_public': true,
            })} ORDER BY base_product_sizes.no`,
          }}
        `,
        !req.query.is_bps
          ? R.QUERY1`
      SELECT count(id) FROM base_products WHERE id in (${subquery})`
          : 0,
        !req.query.is_bps
          ? go(
              G.category.filter(
                sel('cate_list_id', req.params),
                sel('cate_item_id', req.query),
                req.query.lang_col,
              ),
              function (filter_lists) {
                if (!filter_lists.length) throw new Error('404');
                const param = omit(['offset', 'limit'], req.query);
                return each(function (fl) {
                  fl.count = 0;
                  each(function (f) {
                    const selected = !!find((id) => id == f.id, param[`f_${fl.id}`]);
                    if (selected) fl.count++;
                    f.selected = selected;
                  }, fl._.filter_items);
                }, filter_lists);
              },
            )
          : [],
        parseInt(req.params.cate_list_id),
        omit(['offset', 'limit'], req.query),
      ]),
    ([bps, { count }, filter_lists, cate_list_id, query]) => [
      {
        bps,
        count,
        filter_lists,
        sort_by: [
          { id: 'no', name: T('Featured') },
          { id: 'low', name: T('Low to High') },
          { id: 'high', name: T('High to Low') },
        ],
      },
      cate_list_id,
      query,
    ],
  );
};

function get_base_product_ordering(ordering) {
  const no = SQL`base_products.no, base_products.id`;
  if (!ordering || ordering == 'no') return SQL`${no}`;
  else if (ordering == 'low') return SQL`${G.enCL('base_products.price')} + ${G.enCL('print_price')}, ${no}`;
  else if (ordering == 'high')
    return SQL`${G.enCL('base_products.price')} + ${G.enCL('print_price')} desc, ${no}`;
}
